/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_1800)">
				<path
					opacity="0.4"
					d="M12 4.08L17.5218 2.53391C19.3133 2.03228 20.209 1.78147 20.8237 2.01427C21.3596 2.21724 21.7827 2.64035 21.9857 3.17628C22.2185 3.79096 21.9677 4.68672 21.466 6.47824L21.0399 8"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12 4.08008L7.29584 5.39724C4.46617 6.18955 3.05133 6.5857 2.64136 7.25836C2.28678 7.84013 2.25275 8.56239 2.55106 9.17492C2.89597 9.88314 4.26729 10.4106 7.00993 11.4654L9.67255 12.4895C10.1614 12.6775 10.4058 12.7715 10.6114 12.9177C10.7936 13.0473 10.9528 13.2065 11.0823 13.3887C11.2285 13.5943 11.3225 13.8387 11.5105 14.3275L12.5345 16.99C13.5893 19.7327 14.1168 21.104 14.825 21.4489C15.4375 21.7473 16.1598 21.7132 16.7415 21.3587C17.4142 20.9487 17.8104 19.5338 18.6027 16.7041L21.0399 8.00008"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1800">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_1803)">
				<path
					opacity="0.12"
					d="M21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L9.67255 12.4894C10.1614 12.6775 10.4058 12.7715 10.6114 12.9176C10.7936 13.0472 10.9528 13.2064 11.0823 13.3886C11.2285 13.5942 11.3225 13.8386 11.5105 14.3275L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824Z"
					fill="currentColor"
				/>
				<path
					d="M21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L9.67255 12.4894C10.1614 12.6775 10.4058 12.7715 10.6114 12.9176C10.7936 13.0472 10.9528 13.2064 11.0823 13.3886C11.2285 13.5942 11.3225 13.8386 11.5105 14.3275L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1803">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_1809)">
				<path
					d="M22.1644 6.76625C22.7914 4.52685 23.105 3.40715 22.814 2.6388C22.5603 1.9689 22.0314 1.44001 21.3615 1.18629C20.5931 0.895294 19.4734 1.20881 17.234 1.83584L7.23894 4.63446C3.70185 5.62485 1.93331 6.12004 1.42084 6.96085C0.977616 7.68807 0.935078 8.59089 1.30796 9.35656C1.7391 10.2418 3.45325 10.9011 6.88155 12.2197L8.7604 12.9423C9.37144 13.1774 9.67696 13.2949 9.93395 13.4776C10.1617 13.6395 10.3607 13.8385 10.5227 14.0663C10.7054 14.3233 10.8229 14.6288 11.0579 15.2399L11.7804 17.1185C13.099 20.5469 13.7582 22.2611 14.6435 22.6922C15.4092 23.0651 16.312 23.0226 17.0392 22.5794C17.88 22.0669 18.3753 20.2984 19.3657 16.7612L22.1644 6.76625Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1809">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<g clipPath="url(#clip0_2004_1798)">
				<path
					d="M10.5 4.5L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L9.67255 12.4894C10.1614 12.6775 10.4058 12.7715 10.6114 12.9176C10.7936 13.0472 10.9528 13.2064 11.0823 13.3886C11.2285 13.5942 11.3225 13.8386 11.5105 14.3275L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L15 3.24"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1798">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<g clipPath="url(#clip0_2004_1796)">
				<path
					d="M21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L9.67255 12.4894C10.1614 12.6775 10.4058 12.7715 10.6114 12.9176C10.7936 13.0472 10.9528 13.2064 11.0823 13.3886C11.2285 13.5942 11.3225 13.8386 11.5105 14.3275L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1796">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_1806)">
				<path
					opacity="0.32"
					d="M22.1644 6.76576C22.7914 4.52636 23.105 3.40666 22.814 2.63831C22.5603 1.96841 22.0314 1.43952 21.3615 1.1858C20.5931 0.894806 19.4734 1.20832 17.234 1.83536L7.23894 4.63397C3.70185 5.62436 1.93331 6.11955 1.42084 6.96037C0.977616 7.68758 0.935078 8.59041 1.30796 9.35607C1.7391 10.2413 3.45325 10.9006 6.88155 12.2192L8.7604 12.9419C9.37144 13.1769 9.67696 13.2944 9.93395 13.4771C10.1617 13.6391 10.3607 13.8381 10.5227 14.0658C10.7054 14.3228 10.8229 14.6283 11.0579 15.2394L11.7804 17.1181C13.099 20.5464 13.7582 22.2606 14.6435 22.6917C15.4092 23.0646 16.312 23.0221 17.0392 22.5789C17.88 22.0664 18.3753 20.2979 19.3657 16.7607L22.1644 6.76576Z"
					fill="currentColor"
				/>
				<path
					d="M22.2439 1.75637C21.9962 1.50869 21.6965 1.31303 21.3615 1.18618C20.5932 0.895179 19.4735 1.2087 17.2341 1.83573L7.23902 4.63435C3.70193 5.62473 1.93338 6.11993 1.42092 6.96074C0.977692 7.68795 0.935154 8.59078 1.30804 9.35645C1.71223 10.1864 3.24407 10.8177 6.2588 11.9799C6.45978 12.0573 6.66736 12.1372 6.88163 12.2196L7.99357 12.6473C8.00817 12.6529 8.02269 12.6585 8.03705 12.664C8.88639 12.9906 9.31814 13.1541 9.74735 13.1633C10.1332 13.1715 10.5157 13.0903 10.8649 12.9261C11.2599 12.7403 11.5926 12.4076 12.2579 11.7423L22.2439 1.75637Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_1806">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
